import { initVideoRowSliders } from './videoSlider';

export function initVideoPagination() {
    const container = document.querySelector( '.video-guide-blocks-container' );
    const button = document.querySelector( '.load-more-categories' );

    if ( ! container || ! button ) {
        return;
    }

    const tabList = document.getElementById( 'categoryTab' );
    const allTerms = JSON.parse( button.dataset.all || '[]' );
    const perLoad = 5;
    const spinner = button.querySelector( '.loader-spinner' );

    const isCategoryLoaded = function( slug ) {
        return !! document.getElementById( slug );
    };

    const getSearchTerm = function() {
        return button.dataset.search || '';
    };

    const toggleButtonState = function( disable ) {
        button.disabled = disable;
        if ( spinner ) {
            spinner.classList.toggle( 'd-none', ! disable );
        }
    };

    const scrollToElement = function( slug ) {
        const el = document.getElementById( slug );
        if ( el ) {
            el.scrollIntoView( { behavior: 'smooth', block: 'start' } );
        }
    };

    const countLoadedCategories = function() {
        return allTerms.filter( function( t ) {
            return isCategoryLoaded( t.slug );
        } ).length;
    };

    const getNextTermsToLoad = function() {
        const next = [];
        for ( let i = 0; i < allTerms.length && next.length < perLoad; i++ ) {
            const term = allTerms[ i ];
            if ( ! isCategoryLoaded( term.slug ) ) {
                next.push( term.slug );
            }
        }
        return next;
    };

    const loadCategoryBlocks = async function( termsSlugs, scrollSlug, searchTerm ) {
        const params = new URLSearchParams();
        params.append( 'action', 'load_category_blocks' );
        for ( let i = 0; i < termsSlugs.length; i++ ) {
            params.append( 'terms[]', termsSlugs[ i ] );
        }
        if ( searchTerm ) {
            params.append( 'search', searchTerm );
        }

        const res = await fetch( '/wp-admin/admin-ajax.php', {
            method: 'POST',
            body: params,
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        } );

        const data = await res.json();
        if ( data.success ) {
            container.insertAdjacentHTML( 'beforeend', data.data.html );
            initVideoRowSliders();
            if ( scrollSlug ) {
                scrollToElement( scrollSlug );
            }
        }
    };

    const loadSingleCategory = async function( slug ) {
        if ( button.disabled ) {
            return false;
        }

        if ( isCategoryLoaded( slug ) ) {
            scrollToElement( slug );
            return true;
        }

        button.scrollIntoView( { behavior: 'smooth', block: 'center' } );
        await new Promise( function( resolve ) {
            setTimeout( resolve, 500 );
        } );

        toggleButtonState( true );
        try {
            await loadCategoryBlocks( [ slug ], slug, getSearchTerm() );
            if ( countLoadedCategories() >= allTerms.length ) {
                button.remove();
            } else {
                toggleButtonState( false );
            }
            return true;
        } catch ( e ) {
            toggleButtonState( false );
            return false;
        }
    };

    button.addEventListener( 'click', async function() {
        if ( button.disabled ) {
            return;
        }

        toggleButtonState( true );

        const nextTerms = getNextTermsToLoad();
        if ( ! nextTerms.length ) {
            button.remove();
            return;
        }

        try {
            await loadCategoryBlocks( nextTerms, null, getSearchTerm() );
            if ( countLoadedCategories() >= allTerms.length ) {
                button.remove();
            } else {
                toggleButtonState( false );
            }
        } catch ( e ) {
            toggleButtonState( false );
        }
    } );

    if ( tabList ) {
        tabList.addEventListener( 'click', async function( e ) {
            const target = e.target.closest( 'button[data-bs-target]' );
            if ( ! target ) {
                return;
            }

            const slug = target.getAttribute( 'data-bs-target' ).replace( '#', '' );
            await loadSingleCategory( slug );
        } );
    }

    initVideoRowSliders();

    const hash = window.location.hash ? window.location.hash.replace( '#', '' ) : '';
    let found = false;
    for ( let j = 0; j < allTerms.length; j++ ) {
        if ( allTerms[ j ].slug === hash ) {
            found = true;
            break;
        }
    }

    if ( hash && found ) {
        button.scrollIntoView( { behavior: 'smooth', block: 'center' } );
        setTimeout( function() {
            loadSingleCategory( hash );
        }, 500 );
    }
}
